<script lang="ts">
  import { addDataAttrs } from '@centerhealth/fe/heap';

  import { Button } from '@centerhealth/fe/center-kit';
  import { BasicSizes, CtaModel, NavItem } from '@centerhealth/fe/center-kit';

  export let navItems: NavItem[] = [];
  export let cta: CtaModel = null;
  export let gap: BasicSizes = 'small';
</script>

<nav class="main-nav flex">
  <ul class={`inline-flex justify-center flex-wrap items-center gap--${gap}`}>
    {#each navItems as { name, link, active }}
      <li class={['flex', ''].join(' ')}>
        <a
          use:addDataAttrs={{
            action: 'select',
            subAction: 'nav',
            value: name,
          }}
          href={link}
          target={name === 'FAQ' ? '_blank' : ''}
          class:active={active === true}>{name}</a
        >
      </li>
    {/each}
    {#if cta}
      <li>
        {#if cta.link.includes('subscribe')}
          <Button
            heapAttr={{
              action: 'cta',
              subAction: 'subscribe',
              sectionName: 'nav',
            }}
            size="small"
            href={cta.link}>{cta.label}</Button
          >
        {:else}
          <Button
            heapAttr={{
              action: 'cta',
              subAction: 'signup',
              sectionName: 'nav',
            }}
            size="small"
            href={cta.link}>{cta.label}</Button
          >
        {/if}
      </li>
    {/if}
  </ul>
</nav>

<style lang="scss">
  .main-nav li {
    color: #313b44;
    font-size: 18px;
    font-weight: 600;
  }
  .main-nav ul li a:after {
    content: '';
    position: absolute;
    left: 50%;
    margin-left: -20px;
    bottom: 0;
    height: 4px;
    border-radius: 2px;
    transition: all 0.3s;
    top: 30px;
    width: 40px;
    transform: scaleX(0);
  }
  .main-nav ul li a.active:after {
    transform: scaleX(1);
    transition: all 0.3s;
  }

  .main-nav ul li a:hover:after {
    transform: scaleX(1);
    transition: all 0.3s;
  }

  .main-nav ul li a {
    position: relative;
  }

  .main-nav ul li:nth-child(1) a:after {
    background-color: #2ecc71;
  }

  .main-nav ul li:nth-child(2) a:after {
    background-color: #9c88ff;
  }

  .main-nav ul li:nth-child(3) a:after {
    background-color: #e74c3c;
  }

  .main-nav ul li:nth-child(4) a:after {
    background-color: #f39c12;
  }

  .main-nav ul li:nth-child(5) a:after {
    background-color: #9c88ff;
  }

  .main-nav ul li:nth-child(6) a:after {
    background-color: #e74c3c;
  }

  .main-nav ul li:nth-child(7) a:after {
    background-color: #f39c12;
  }
  .main-nav ul li:nth-child(8) a:after {
    background-color: #2ecc71;
  }
  .gap--small {
    @apply gap-4;
  }
  .gap--medium {
    @apply lg:gap-6 xl:gap-7;
  }
</style>
